import { ToastContainer } from 'react-toastify';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import PublicHeader from '../PublicHeader';

const Layout = () => (
  <>
    <ToastContainer className='mt-16' />
    <PublicHeader />
    <div className='flex min-h-screen flex-col justify-between'>
      <div className='grow'>
        <Outlet />
      </div>
      <Footer className='justify-self-end' />
    </div>
  </>
);

export default Layout;
